import { DataGridRef } from 'devextreme-react/data-grid';
import React from 'react';
import { Entities, Helpers } from '../../exports';
import { RxEventEmitter } from '@bimser/core';
import { FlexPanelActionTypes } from '../../../BCFlexLayout';

export const useEventEmitter = (
	name: Entities.DataGrids,
	dxDataGridRef: React.RefObject<DataGridRef>
) => {
	React.useEffect(() => {
		RxEventEmitter.listen(FlexPanelActionTypes.DIMENSIONS_UPDATED, {
			next() {
				dxDataGridRef.current?.instance()?.updateDimensions();
			}
		});
		Helpers.EventEmitter.listen(name, [
			{
				name: Entities.EventEmitterTypes.Refresh,
				handler: {
					next() {
						dxDataGridRef.current?.instance().refresh();
					}
				}
			},
			{
				name: Entities.EventEmitterTypes.BeginLoading,
				handler: {
					next() {
						dxDataGridRef.current?.instance().beginCustomLoading(null);
					}
				}
			},
			{
				name: Entities.EventEmitterTypes.EndLoading,
				handler: {
					next() {
						dxDataGridRef.current?.instance().endCustomLoading();
					}
				}
			},
			{
				name: Entities.EventEmitterTypes.Insert,
				handler: {
					next(data) {
						dxDataGridRef.current?.instance().getDataSource().store().insert(data);
					}
				}
			}
		]);
	}, []);
};
